import { render, staticRenderFns } from "./Labeled.vue?vue&type=template&id=66749d3c&scoped=true&lang=pug"
import script from "./Labeled.vue?vue&type=script&lang=js"
export * from "./Labeled.vue?vue&type=script&lang=js"
import style0 from "./Labeled.vue?vue&type=style&index=0&id=66749d3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66749d3c",
  null
  
)

export default component.exports